import { PolicyDocumentsActionTypes, } from './types';
import { createAsyncMapAction } from '~lib/shared/redux/actions';
export const documentsByPolicyId = createAsyncMapAction(PolicyDocumentsActionTypes.DOCUMENTS_BY_POLICY_ID, p => p.policyId);
export const sendDocuments = createAsyncMapAction(PolicyDocumentsActionTypes.SEND_DOCUMENTS, p => p.nonce);
